import { theme } from '../../../theme';
import { ThemeProvider } from '@mui/material/styles';
import OrderTable from './OrderTable';
import {useState } from 'react';
import { Typography } from '@mui/material';

const OrderList = () => {

  const [orderId, setOrderId] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [orderStatus, setOrderStatus] = useState('')

  return (
    <ThemeProvider theme={theme}>
        <>
          <Typography
            variant="h5" fontWeight="bold" mb={2}>
            Order Management
          </Typography>
          <OrderTable
            orderId={orderId}
            setOrderId={setOrderId}
            orderStatus={orderStatus}
            setOrderStatus={setOrderStatus}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
          />
        </>
    </ThemeProvider>
  );
};

export default OrderList;
